import styled from 'styled-components';

export const MetricsTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
